export default {
  // 标题
  device: '设备',

  // 设备信息
  noDrone: '无无人机',
}
